<template>
  <div class="basic_wrap">
    <van-row class="topLogoItem">
      <van-col span="24" class="logoLang">
        <img src="../images/common/logo.png" style="width: 130px" />

        <p class="languageList" @click="$router.push('/language')">
          <span style="padding: 0px 4px" class="ActiveLanguage">EN</span>/<span
            style="padding: 0px 4px"
            >CN</span
          >
        </p>
      </van-col>
    </van-row>
    <form class="form">
      <div>
        <van-row>
          <van-col span="24">
            <div class="forgetpweTopic">
              <p class="forgetpweTopicP">{{ $t("forgetpwe.reset") }}</p>
            </div>
          </van-col>
        </van-row>
        <van-row
          style="margin: 30px 20px 15px; border-bottom: 1px solid #ffffffa3"
        >
          <van-col span="12" style="text-align: center">
            <div
              class="optionTab"
              @click="showInput('mobile')"
              v-bind:class="this.phoneInput == true ? 'activeTab' : ''"
            >
              <p>{{ $t("forgetpwe.mobile") }}</p>
              <img
                src="../images/login/activeArrow.png"
                v-show="phoneInput"
                style="height: 12px"
              />
            </div>
          </van-col>
          <van-col span="12" style="text-align: center">
            <div
              class="optionTab"
              @click="showInput('email')"
              v-bind:class="this.emailInput == true ? 'activeTab' : ''"
            >
              <p>{{ $t("forgetpwe.phoneNumber") }}</p>
              <img
                src="../images/login/activeArrow.png"
                v-show="emailInput"
                style="height: 12px"
              />
            </div>
          </van-col>
        </van-row>

        <!-- --------------------- show phone number ---------- -->
        <van-row v-show="phoneInput">
          <van-row style="margin-top: 30px">
            <van-col span="24"
              ><p class="labelText">{{ $t("forgetpwe.mobile") }}:</p></van-col
            >
          </van-row>
          <div class="item">
            <div
              class="icon"
              @click="showCountryPicker = true"
              style="border-right: 1px solid #969799"
            >
              <img
                :src="countryFlagUrl"
                style="height: 18px; width: auto; margin-right: 5px"
              />
              <span :v-model="countryCode" style="white-space: nowrap">{{
                countryCode
              }}</span>
            </div>
            <input type="text" class="inp" v-model.trim="data.mobile" />
          </div>
        </van-row>

        <!-- --------------------- show email ---------- -->

        <van-row v-show="emailInput">
          <van-row style="margin-top: 30px">
            <van-col span="24"
              ><p class="labelText">
                {{ $t("forgetpwe.phoneNumber") }}:
              </p></van-col
            >
          </van-row>
          <div class="item">
            <span class="icon">
              <img src="../images/login/email.png" alt="" />
            </span>
            <input type="text" class="inp" v-model.trim="data.email" />
          </div>
        </van-row>

        <!-- ---------- password------------ -->

        <van-row style="margin-top: 20px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("forgetpwe.newPassword") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/login/lock.png" alt=""
          /></span>
          <input :type="password" class="inp" v-model.trim="data.password" />
          <div
            class="eye_bi"
            @click="showPwd"
            :class="password == 'text' ? 'eye' : ''"
          ></div>
        </div>
        <!-- ---------- re password ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{ $t("forgetpwe.rePassword") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/password.png" alt=""
          /></span>
          <input :type="spassword" class="inp" v-model.trim="data.spassword" />
          <div
            class="eye_bi"
            @click="showRePwd"
            :class="spassword == 'text' ? 'eye' : ''"
          ></div>
        </div>

        <!-- ---------- sms code ------ -->
        <!-- <div v-if="show_sms > 0"> -->
        <div>
          <van-row style="margin-top: 15px">
            <van-col span="24"
              ><p class="labelText">{{ $t("forgetpwe.code") }}:</p></van-col
            >
          </van-row>
          <div class="item">
            <span class="icon"
              ><img src="../images/register/OTP.png" alt=""
            /></span>
            <input type="text" class="inp" v-model.trim="data.code" />
            <van-count-down
              :time="time"
              class="btn get_code"
              @finish="timeCall"
            >
              <template v-slot="timeData">
                <span @click="sendcode">{{
                  timeData.seconds > 0 ? timeData.seconds : $t("forgetpwe.send")
                }}</span>
              </template>
            </van-count-down>
          </div>
        </div>

        <van-row>
          <van-col
            span="24"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div type="submit" class="forgetpwe_btn" @click="submit">
              {{ $t("forgetpwe.submit") }}
            </div>
          </van-col>
        </van-row>
      </div>

      <van-divider
        :style="{ borderColor: '#ffffff', padding: '30px 20px 0px' }"
      >
      </van-divider>
      <van-row style="padding-top: 20px">
        <van-col span="24" style="text-align: center">
          <p style="font-size: 13px; color: #ffffff">
            {{ $t("forgetpwe.noAccount") }}
            <router-link to="/register"
              ><span style="color: #f3da2f">{{
                $t("forgetpwe.createAccount")
              }}</span></router-link
            >
          </p>
        </van-col>
      </van-row>
    </form>
    <van-popup v-model="showCountryPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="countryCodeList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :confirm-button-text="$t('bottomSheet.confirmPopup')"
        :cancel-button-text="$t('bottomSheet.cancelPopup')"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Picker, CountDown, Col, Row, Divider } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Popup).use(Picker).use(Row).use(Col).use(Divider);

export default {
  name: "forgetpwd",
  data() {
    return {
      time: 0,
      data: {
        mobile: "",
        code: "",
        password: "",
        email: "",
        spassword: "",
      },
      lang: this.$i18n.locale || "en_us",
      password: "password",
      spassword: "password",
      phoneInput: true,
      emailInput: false,
      showCountryPicker: false,
      countryCode: "",
      countryCodeList: [],
      countryCodesResponse: [],
      countryFlagUrl: "",
    };
  },
  created() {
    // this.$parent.footer("user", false);
  },
  mounted() {
    this.getCountryCodes();
  },
  methods: {
    showInput(action) {
      this.data.mobile = "";
      this.data.password = "";
      this.data.email = "";
      switch (action) {
        case "mobile":
          this.emailInput = false;
          this.phoneInput = true;
          break;
        case "email":
          this.phoneInput = false;
          this.emailInput = true;
          break;
        default:
          break;
      }
    },

    onConfirm(value, index) {
      this.countryFlagUrl = this.countryCodesResponse[index].flag;
      this.countryCode = value;
      this.showCountryPicker = false;
    },

    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    showRePwd() {
      if (this.spassword == "password") {
        this.spassword = "text";
      } else {
        this.spassword = "password";
      }
    },

    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (this.phoneInput && !this.data.mobile) {
        this.$toast(this.$t("forgetpwe.phoneNumberEmpty"));
        return;
      }
      if (!this.phoneInput && !this.data.email) {
        this.$toast(this.$t("forgetpwe.emailEmpty"));
        return;
      }

      this.is_send = true;

      Fetch("/index/forgetpwd_code", {
        identifier: this.phoneInput
          ? this.countryCode + this.data.mobile
          : this.data.email,
        type: this.phoneInput ? 1 : 2,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t("forgetpwe.sendSuccess"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
      if (this.phoneInput && !this.data.mobile) {
        this.$toast(this.$t("forgetpwe.phoneNumberEmpty"));
        return;
      }
      if (!this.phoneInput && !this.data.email) {
        this.$toast(this.$t("forgetpwe.emailEmpty"));
        return;
      }

      if (!this.data.password) {
        this.$toast(this.$t("forgetpwe.newPasswordEmpty"));
        return;
      }

      if (this.data.password != this.data.spassword) {
        this.$toast(this.$t("forgetpwe.passwordNotMatch"));
        return false;
      }

      if (!this.data.code) {
        this.$toast(this.$t("forgetpwe.codeEmpty"));
        return;
      }

      Fetch("/index/forgetpwd_nologin", {
        identifier: this.phoneInput
          ? this.countryCode + this.data.mobile
          : this.data.email,
        password: this.data.password,
        code: this.data.code,
        type: this.phoneInput ? 1 : 2,
      })
        .then(() => {
          this.$toast({
            background: "#07c160",
            message: this.$t("forgetpwe.success"),
          });
        })
        .then(() => {
          this.$router.replace("/login");
        });
    },
    getCountryCodes() {
      Fetch("/Phone/phonenum_country").then((r) => {
        this.countryCodesResponse = r.data;
        if (this.countryCodesResponse.length > 0) {
          this.countryFlagUrl = this.countryCodesResponse[0].flag;
          this.countryCode = this.countryCodesResponse[0].phone_code;
          r.data.forEach((item) => {
            this.countryCodeList.push(item.phone_code);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  background: url(../images/startpage/splashBg.png);
  background-size: 100% 100%;
  min-height: 100vh;
}

.topLogoItem {
  align-items: center;
  display: flex;
  padding: 20px;
  padding-top: 50px;
  position: relative;
}

.language img {
  height: 36px;
}

.form {
  padding: 20px;
  margin-top: 10px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.item_reset_pwd {
  font-size: 14px;
  color: #3d96ff;
  text-align: right;
  margin-top: 10px;
  line-height: 20px;
}
.van-checkbox {
  margin-top: 20px;
}
.reset_pwd {
  color: #f3da2f;
  font-size: 13px;
  display: block;
}

.get_code {
  height: 38px;
  line-height: 48px;
  font-size: 12px;
  color: #247575;
  margin-right: 10px;
  font-weight: 700;
}

.forgetpwe_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  background: unset;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 40px;
}

.forgetpweTopic {
  text-align: center;
}

.forgetpweTopicP {
  font-size: 32px;
  padding: 8px;
  color: #ffffff;
  font-weight: 700;
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.eye_bi {
  margin-right: 10px !important;
}

.optionTab {
  padding: 8px 5px 0px;
  color: #ffffff;
  font-size: 20px;
}

.activeTab {
  color: #fff;
  font-weight: 700;
}

.languageList {
  color: #ffffff;
  font-size: 15px;
  border: 1px solid #ffffff;
  padding: 5px 2px;
  border-radius: 5px;
  width: 75px;
  right: 12px;
  position: absolute;
  text-align: center;
}

.logoLang {
  align-items: center;
  display: flex;
}

.ActiveLanguage {
  color: #f3da2f;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 600000s 0s, color 600000s 0s;
}
</style>
